import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	Grid,
	Typography,
} from "@mui/material";
import { FC } from "react";
import { isSafeHttpUrl, isSafeMailtoUrl } from "../../utils/safeUrl";

export type OptionHelpProps = {
	id: string;
	url?: string;
	title: string;
	description: string;
	image: string;
	buttonText: string;
	colorButton:
		| "inherit"
		| "primary"
		| "secondary"
		| "success"
		| "error"
		| "info"
		| "warning"
		| undefined;
	buttonVariant: "text" | "outlined" | "contained" | undefined;
};

const OptionHelp: FC<OptionHelpProps> = (props: OptionHelpProps) => {
	const {
		title,
		description,
		image,
		buttonText,
		colorButton,
		buttonVariant,
		url,
	} = props;

	// SIMS-5934 / Aikido XSS: only render navigation for allowlisted schemes.
	// Prefer <a href> (no window.open / location sink) so javascript:/data: can
	// never be navigated even if a future call-site passes a tainted string.
	const safeMailto = isSafeMailtoUrl(url) ? url : undefined;
	const safeHttp = isSafeHttpUrl(url) ? url : undefined;
	const safeHref = safeMailto ?? safeHttp;

	const actionButton = (
		<Button
			size="large"
			sx={{ fontWeight: "600" }}
			color={colorButton}
			variant={buttonVariant}
			disabled={!safeHref}
		>
			{buttonText}
		</Button>
	);

	return (
		<Grid item sm={6} md={4}>
			<Card sx={{ minHeight: "29rem" }}>
				<CardContent>
					<Box
						sx={{ height: "25rem" }}
						display="flex"
						flexDirection="column"
						gap="1rem"
						flexWrap="wrap"
					>
						<CardMedia
							sx={{ maxWidth: "100%", maxHeight: "210px" }}
							component="img"
							image={image}
							alt="green iguana"
						/>
						<div style={{ textAlign: "left" }}>
							<Typography variant="titleSmallOptionHelp">{title}</Typography>
						</div>
						<Typography variant="bodyOptionHelp" color="text.secondary">
							{description}
						</Typography>
					</Box>
				</CardContent>
				<CardActions sx={{ padding: "15px", minHeight: "6.5rem" }}>
					{safeHref ? (
						<a
							href={safeHref}
							{...(safeHttp
								? { target: "_blank", rel: "noopener noreferrer" }
								: {})}
							style={{
								textDecoration: "none",
								display: "inline-block",
								width: "100%",
							}}
						>
							{actionButton}
						</a>
					) : (
						actionButton
					)}
				</CardActions>
			</Card>
		</Grid>
	);
};
export default OptionHelp;
